import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { searchAPI } from '../../services/api';
import styles from './PopularKeywords.module.css';

const PopularKeywords = ({ limit = 10, onKeywordClick }) => {
  const [keywords, setKeywords] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPopularKeywords();
  }, [limit]);

  const fetchPopularKeywords = async () => {
    try {
      const response = await searchAPI.getPopularKeywords(limit);
      setKeywords(response.data.data || []);
    } catch (error) {
      console.error('Failed to fetch popular keywords:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleKeywordClick = (keyword) => {
    if (onKeywordClick) {
      onKeywordClick(keyword);
    }
  };

  if (loading) {
    return (
      <div className={styles.container}>
        <div className={styles.sectionHeader}>
          <h2 className={styles.sectionTitle}>
            <span className={styles.titleIcon}>🔥</span>
            热门搜索
          </h2>
        </div>
        <div className={styles.loadingState}>
          <div className={styles.loadingSpinner}></div>
        </div>
      </div>
    );
  }

  // 如果没有后台数据，显示默认热门关键词
  const displayKeywords = keywords.length > 0 ? keywords : [
    '电影',
    '电视剧',
    '软件',
    '电子书',
    '教程',
    '游戏',
    '音乐',
    '学习资料',
    '破解版',
    '高清'
  ];

  return (
    <div className={styles.container}>
      <div className={styles.sectionHeader}>
        <h2 className={styles.sectionTitle}>
          <span className={styles.titleIcon}>🔥</span>
          热门搜索
        </h2>
      </div>
      <div className={styles.keywordsGrid}>
        {displayKeywords.map((keyword, index) => (
          <Link
            key={index}
            to={`/search?q=${encodeURIComponent(keyword)}`}
            className={styles.keywordTag}
            onClick={() => handleKeywordClick(keyword)}
          >
            <span className={styles.keywordRank}>{index + 1}</span>
            <span className={styles.keywordText}>{keyword}</span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default PopularKeywords;
